import React, { Component } from 'react';

class ModulePreview extends Component {

    dayChecker = (week, day, lessons) => {
        if (!lessons[0]) {
            return false
        }
        if (lessons[0].lessons.filter(l => l.WeekNum === week && l.DayOfWeek === day).length > 0) {
            return true
        }
        return false
    }

    render() {
        const { lessons, maxWeeks } = this.props
        let preview = [];
        
        for (let i = 1; i < maxWeeks + 1; i++) {
            preview.push(
                <div className='modulePreviewRow' key={i}>
                    <div key={i + '_' + 1} className={this.dayChecker(i, 1, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 2} className={this.dayChecker(i, 2, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 3} className={this.dayChecker(i, 3, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 4} className={this.dayChecker(i, 4, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 5} className={this.dayChecker(i, 5, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 6} className={this.dayChecker(i, 6, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                    <div key={i + '_' + 7} className={this.dayChecker(i, 7, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
                </div>
            )
        }

        return (
            <div>
                {preview}
            </div>
            // <div>
            //     <div className='modulePreviewRow'>
            //         <div className={this.dayChecker(1, 1, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 2, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 3, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 4, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 5, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 6, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(1, 7, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //     </div>

            //     <div className='modulePreviewRow'>
            //         <div className={this.dayChecker(2, 1, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 2, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 3, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 4, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 5, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 6, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(2, 7, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //     </div>

            //     <div className='modulePreviewRow'>
            //         <div className={this.dayChecker(3, 1, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 2, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 3, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 4, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 5, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 6, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(3, 7, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //     </div>

            //     <div className='modulePreviewRow'>
            //         <div className={this.dayChecker(4, 1, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 2, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 3, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 4, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 5, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 6, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //         <div className={this.dayChecker(4, 7, lessons) ? 'modulePreviewTrue' : 'modulePreviewFalse'}></div>
            //     </div>
            // </div>

        )

    }
}

export default ModulePreview;


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/ModulePreview.js